<template>
	<img :src="path" alt="icon" :height="height" :width="width" />
</template>

<script>
export default {
	name: "Icon",
	props: {
		name: {},
		width: {
			default: "24px",
		},
		height: {
			default: "24px",
		},
		modifier: {
			default: null,
		},
		fixAlign: {
			default: true,
		},
		active: {
			default: false,
		},
	},
	computed: {
		path: function () {
			return this.active
				? require("../../../assets/icons/menu/" +
						this.name +
						"-icon-white.svg")
				: require("../../../assets/icons/menu/" +
						this.name +
						"-icon.svg");
		},
	},
};
</script>

<style scoped>
</style>